// This size is the best resoltion to ditch the fixed navigation from
// displaying. Any larger than this and we run into issues where it covers too
// much content in the site
export const FIXED_NAV_BREAKPOINT_WIDTH = 650;

// This is the responsive size that we should start showing a mobile view
export const MOBILE_BREAKPOINT_WIDTH = 576;
